export default {
  /**
   * Saves the data into the provided inMemoryDb (simple object).
   * DANGER: It was intended to set state values too here. HOWEVER this breaks reactivity!!!
   * @param {String} moduleId - the module id
   * @param {Object} state - the module vuex state
   * @param {Object} inMemoryDb - the in-memory-db object
   * @param {Object} data - the data object to store
   */
   saveDataToInMemoryStore(moduleId, state, inMemoryDb, data) {

    console.time(`saveData in non-reactive-in-memory store ${moduleId}`);
    Object.keys(data).forEach((key) => {
      if (inMemoryDb[key]) {
        // console.log(`set ${key} to ${moduleId} in-memory-store`);
        inMemoryDb[key] = data[key];
      }
    });
    console.timeEnd(`saveData in non-reactive-in-memory store ${moduleId}`);
  },
};
